export default {
  ADMIN_PAGE_FEEDBACK_REQUESTED: 'ADMIN_PAGE_FEEDBACK_REQUESTED',
  ADMIN_PAGE_FEEDBACK_REQUEST_COMPLETE: 'ADMIN_PAGE_FEEDBACK_REQUEST_COMPLETE',
  ADMIN_PAGE_FEEDBACK_REQUEST_FAILED: 'ADMIN_PAGE_FEEDBACK_REQUEST_FAILED',
  ADMIN_PAGE_FEEDBACK_UPDATE_SUBMITTED: 'ADMIN_PAGE_FEEDBACK_UPDATE_SUBMITTED',
  ADMIN_PAGE_FEEDBACK_UPDATE_COMPLETE: 'ADMIN_PAGE_FEEDBACK_UPDATE_COMPLETE',
  ADMIN_PAGE_FEEDBACK_UPDATE_FAILED: 'ADMIN_PAGE_FEEDBACK_UPDATE_FAILED',
}